module.exports = __webpack_public_path__ + "img/rave-maniaca.43366de8.jpg";